import { v4 as uuid } from 'uuid';

import { updateInternalCommissions, updateOutsideCommissions } from 'bundles/backoffice/vouchers/helpers/commissions';

// This only handles a deal's gross commission amount and internal/outisde
// commission gross amounts and percents, accounting for pre-split deductions.
// If we must handle commission updates on the deal form after an active voucher
// is present (and therefore care about splits, commission plans, etc.), then
// consider using updateCommissions from vouchers/helpers/commissions.js instead.
export function recalculateBrokerCommissions(deal, commissions = JSON.parse(JSON.stringify(deal.commissions))) {
  const preSplitDeductionAmount = deal.deductions.reduce((sum, deduction) => {
    return sum + (deduction.deductFromHouse ? 0 : deduction.amount);
  }, 0);

  deal = { ...deal, commissions, totalDeduction: preSplitDeductionAmount };
  updateOutsideCommissions(deal);
  updateInternalCommissions(deal);
  return commissions;
}

export function initializeCommission(commission) {
  return { ...commission, localId: uuid() };
}

export function addPrimaryPlanToCommissionChanges(changes, userOptions) {
  // Assumes that broker can only be changed on an unpersisted commission, as we don't want to do
  // this for persisted commissions
  if (changes.hasOwnProperty('broker')) {
    const userOption = userOptions.find(user => user.value === changes.broker?.id);
    changes.commissionPlanId = userOption?.primaryCommissionPlanId || null;
  }
}
